var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 12.045",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.364 10.472 2.52 6.983l.781-.64L5.44 8.97l7.17-7.17.71.71z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selected.df8606bfd25d0310d32fc5e98b7c5fd0.svg";